import PropTypes from 'prop-types';
import React from 'react';
import SVGInline from 'react-svg-inline';

// Helpers
import isMinimalView from 'services/isMinimalView';
import { wpUrl } from 'services/fetch';

// SVGs
import prbLogo from 'assets/logo-prb.svg';

// Styles
import styles from './copyright.scss';

/**
 * A component that contains copyright information and a link back to the
 * canonical version of the post, if embedded. Does not display if not in an
 * embed or export context.
 */
export default class Copyright extends React.PureComponent {
  /**
   * Renders the control based on the value of props.
   */
  render() {
    const {
      isEmbedded,
      isExporting,
      originalPath,
    } = this.props;

    // Don't render if we are not embedding or exporting.
    if (!isMinimalView({ isEmbedded, isExporting })) {
      return null;
    }

    // Remove renderType from original URL.
    const relativePath = originalPath
      .replace(/^\/embed\//, '/')
      .replace(/^\/image-export\//, '/');

    return (
      <p>
        <a href="https://www.prb.org" target="_parent">
          <SVGInline
            svg={prbLogo}
            className={styles.logo}
          />
        </a>
        © {(new Date()).getFullYear()} Population Reference Bureau.
        All Rights Reserved.
        {isEmbedded &&
          <a
            className={styles.canonicalLink}
            href={`${wpUrl()}${relativePath}`}
            target="_parent"
          >
            View in the PRB Data Center.
          </a>
        }
      </p>
    );
  }
}

Copyright.propTypes = {
  isEmbedded: PropTypes.bool,
  isExporting: PropTypes.bool,
  originalPath: PropTypes.string,
};

Copyright.defaultProps = {
  isEmbedded: false,
  isExporting: false,
  originalPath: '',
};



// WEBPACK FOOTER //
// ./app/components/copyright/index.js